export default function isUnknownObject(value) {
  return value != null && typeof value === 'object';
}
//# sourceMappingURL=isUnknownObject.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/isUnknownObject.js
// module id = 201
// module chunks = 0 1